import PropTypes from "prop-types";
import { getMembership } from "../../api/membership";
import React, { PureComponent } from "react";
import * as membershipActions from "../../actions/membershipActions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Page from "../Page";
import Box from "../Box";
import LoadingContent from "../LoadingContent";
import MemberSavings from "../MemberSavings";
import * as config from "../../config";

class MembershipPage extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        registrationMembershipType: PropTypes.string,
        me: PropTypes.object.isRequired,
        storeJoinRenewMembershipType: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            membership: {},
            loading: true,
        };
    }

    componentDidMount = () => {
        if (this.props.me.availableMembershipTypes.filter(m => !m.disabledForUser).length === 0) {
            this.props.history.push("/sessions");
        } else {
            this._getMembership();
        }
    };

    _getMembership = () => {
        this.setState({ loading: true });        

        let registrationMembershipType = this.props.registrationMembershipType;
        if (!registrationMembershipType) {
            registrationMembershipType = "NP Member";
        }

        getMembership(registrationMembershipType, localStorage.getItem(config.storageKeys.promoCode))
            .then(response => {
                this.setState({
                    membership: response,
                });

                this.setState({ loading: false });
            });
    };

    _goToNext = joinOrRenew => {
        if (joinOrRenew) {
            this.props.history.push("/membership-type");
        } else {
            this.props.storeJoinRenewMembershipType("");
            this.props.history.push("/sessions");
        }
    }

    _isNonMember = () => {
        const { membershipStatus } = this.props.me;
        return (membershipStatus === 0 || membershipStatus === 3) && !this.props.me.person.isMember;
    };

    _renderMemberBenefits = () => {
        if (this._isNonMember()) {
            return (
                <ul className="benefits">
                    <li>Access to the AANP CE Center which contains hundreds of educational activities for NP’s many of which are free to members.</li>
                    <li>Free subscriptions to AANP’s two peer-reviewed journals that offer articles, research and continuing education.</li>
                    <li>Exclusive discounts and savings, including on digital clinical reference tools and the American Academy of Nurse Practitioners Certification Board (AANPCB) application.</li>
                    <li>Opportunity to join AANP's Specialty Practice Groups, members-only online communities for a number of therapeutic areas and professional interests.</li>
                    <li>Exclusive, members-only scholarship and grant opportunities.</li>
                    <li>Advocacy for your practice and the NP role—on Capitol Hill and in all 50 states and U.S. territories.</li>
                </ul>
            );                
        } else {
            return (
                <ul className="benefits">
                    <li>Access to the AANP CE Center which contains hundreds of educational activities for NP’s many of which are free to members.</li>
                    <li>Free subscriptions to AANP’s two peer-reviewed journals that offer articles, research and continuing education.</li>
                    <li>Exclusive discounts and savings, including on digital clinical reference tools and the American Academy of Nurse Practitioners Certification Board application.</li>
                    <li>Opportunity to join AANP's Specialty Practice Groups, members-only online communities on a number of therapeutic areas and professional interests.</li>
                    <li>Exclusive, members-only scholarship and grant opportunities.</li>
                    <li>Advocacy for your practice and the NP role—on Capitol Hill and in all 50 states and U.S. territories.</li>
                </ul>
            );            
        }
        
    };

    render() {
        if (this.state.loading) {
            return <LoadingContent />
        }
        let { membership } = this.state;

        return (
            <Page title="Conference Registration">
                <Box title="Register Now!">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="inner-content mb-2">
                                <MemberSavings
                                    membership={membership}
                                    me={this.props.me}
                                    registrationMembershipType={this.props.registrationMembershipType}
                                    headerText="Join Now and Save!"
                                    showCta={true} />

                            </div>
                        </div>
                    </div>
                    <div className="divider d-lg-none" />
                    <div className="row mb-2">
                        <div className="col-lg-12">
                            <div className="inner-content">
                                <h1>Member Benefits</h1>
                                {this._renderMemberBenefits()}
                            </div>
                        </div>
                    </div>
                    
                    <div className="button-row">
                        <div className="button-container pr-3">
                            <div className="inner-content">
                                {this._isNonMember() && 
                                <button className="btn btn-primary btn-block" onClick={e => this._goToNext(true)}>Join Now!</button>
                                } 
                                {!this._isNonMember() &&
                                <button className="btn btn-primary btn-block" onClick={e => this._goToNext(true)}>Renew Now!</button>
                                }
                            </div>
                        </div>                  
                        <div className="text-center text-vertical-center text-or">OR</div>  
                        <div className="button-container pl-3">
                            <div className="inner-content">
                                {this._isNonMember() &&
                                <button className="btn btn-primary btn-block" onClick={e => this._goToNext(false)}>Continue without Joining</button>
                                }
                                {!this._isNonMember() &&
                                <button className="btn btn-primary btn-block" onClick={e => this._goToNext(false)}>Continue without Renewing</button>
                                }
                            </div>
                        </div>                        
                    </div>
                </Box>
            </Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {        
        registrationMembershipType: state.membership.registrationMembershipType,
        me: state.account.me,
    };
};

export default withRouter(connect(mapStateToProps, membershipActions)(MembershipPage));